import { isUndefined } from 'lodash';
import React from 'react';
import { ReactStripeElements, StripeProvider } from 'react-stripe-elements';

import { STRIPE_SCRIPT_URL } from '../constants';

interface State {
  stripe: stripe.Stripe | null;
}
interface OwnProps {
  apiKey: string;
}
type Props = ReactStripeElements.StripeProviderProps & OwnProps;

export class BillingProvider extends React.Component<Props, State> {
  private _isMounted: boolean;

  constructor(props: Props) {
    super(props);

    this._isMounted = false;
    this.state = {
      stripe: null
    };
  }

  public componentDidMount() {
    if (!this.isStripeLoaded()) {
      this.loadStripeAsynchronously();
      return;
    }

    this.setState({
      stripe: window.Stripe(this.props.apiKey)
    });
  }

  public componentWillUnmount() {
    this._isMounted = false;
  }

  public render(): JSX.Element {
    const { stripe } = this.state;

    return <StripeProvider stripe={stripe}>{this.props.children}</StripeProvider>;
  }

  /**
   * Add stripe script at the end of the body and allow us to load
   * asynchronously.
   * @see https://github.com/stripe/react-stripe-elements/tree/7bc56c589b6348b7255937a62aafed163934f078/demo/async
   */
  private loadStripeAsynchronously = () => {
    this._isMounted = true;

    const { apiKey } = this.props;
    const stripeJs = document.createElement('script');

    stripeJs.src = STRIPE_SCRIPT_URL;
    stripeJs.async = true;
    stripeJs.onload = () => {
      if (!this._isMounted) {
        return;
      }

      this.setState({
        stripe: window.Stripe(apiKey)
      });
    };

    document.body && document.body.appendChild(stripeJs);
  };

  private isStripeLoaded(): boolean {
    return !isUndefined(window.Stripe);
  }
}
